<template>
  <div class="outer-wrap">
    <div class="dark-overlay"></div>
    <div id="settings-outerwrap">
      <div class="settings-container">
        <!-- Loading Overlay -->
        <transition name="load">
          <SmallLoadingLogo v-if="!this.loaded" />
        </transition>
        <!-- Heading -->
        <div id="settings-header" class="noselect">
          <h1>{{ $t("message.settings") }}</h1>
          <a @click="closeMe" class="close"></a>
        </div>
        <!-- Opzioni sulla sinistra -->
        <div id="side-options" class="noselect">
          <div class="options">
            <a
              @click="
                curOption = 'deck';
                curTab = 'manage';
              "
              :class="{ active: curOption === 'deck', disabled: isLambro || !checkSensType('deck') }"
              >{{ $t("message.decks") }}
            </a>
            <a
              @click="
                curOption = 'tiltmeter';
                curTab = 'manage';
              "
              :class="{ active: curOption === 'tiltmeter', disabled: isLambro || !checkSensType('tiltmeter') }"
              >{{ $t("message.tiltmeters") }}
            </a>
            <a
              @click="
                curOption = 'accelerometer';
                curTab = 'manage';
              "
              :class="{ active: curOption === 'accelerometer', disabled: isLambro || !checkSensType('accelerometer') }"
              >{{ $t("message.accelerometers") }}
            </a>
            <a
              @click="
                curOption = 'crackmeter';
                curTab = 'manage';
              "
              :class="{ active: curOption === 'crackmeter', disabled: isLambro || !checkSensType('crackmeter') }"
              >{{ $t("message.crackmeters") }}
            </a>
            <div class="horiz-divider"></div>
            <a
              @click="
                curOption = 'structure';
                curTab = 'spans';
              "
              :class="{ active: curOption === 'structure' }"
              >{{ $t("message.structure") }}
            </a>
            <div class="horiz-divider"></div>
            <a
              @click="
                curOption = 'notifications';
                curTab = 'mail';
              "
              :class="{ active: curOption === 'notifications' }"
              >{{ $t("message.notifications") }}
            </a>
            <a
              v-if="multiUser"
              @click="
                curOption = 'users';
                curTab = 'users';
              "
              :class="{ active: curOption === 'users' }"
              >{{ $t("message.users") }}
            </a>
          </div>
        </div>
        <!-- Tabs -->
        <div id="tab">
          <a @click="curTab = 'manage'" :class="{ active: curTab === 'manage' }" v-if="checkIfTabAvailable('manage')"
            >{{ $t("message.manage") }}
          </a>
          <a @click="curTab = 'spans'" :class="{ active: curTab === 'spans' }" v-if="checkIfTabAvailable('spans')"
            >{{ $t("message.spans") }}
          </a>
          <a @click="curTab = 'samplerate'" :class="{ active: curTab === 'samplerate' }" v-if="checkIfTabAvailable('samplerate')"
            >Sample Rate
          </a>
          <a @click="curTab = 'threshold'" :class="{ active: curTab === 'threshold' }" v-if="checkIfTabAvailable('threshold')"
            >{{ $t("message.alertThreshold") }}
          </a>
          <a @click="curTab = 'resolution'" :class="{ active: curTab === 'resolution' }" v-if="checkIfTabAvailable('resolution')"
            >{{ $t("message.resolution") }}
          </a>
          <a
            @click="curTab = 'activationThreshold'"
            :class="{ active: curTab === 'activationThreshold' }"
            v-if="checkIfTabAvailable('activationThreshold')"
            >{{ $t("message.activationThreshold") }}
          </a>
          <a @click="curTab = 'compensation'" :class="{ active: curTab === 'compensation' }" v-if="checkIfTabAvailable('compensation')"
            >{{ $t("message.compensation") }}
          </a>
          <a @click="curTab = 'unit'" :class="{ active: curTab === 'unit' }" v-if="checkIfTabAvailable('unit')"
            >{{ $t("message.mesUnit") }}
          </a>
          <a @click="curTab = 'position'" :class="{ active: curTab === 'position' }" v-if="checkIfTabAvailable('position')"
            >{{ $t("message.positioning") }}
          </a>
          <a @click="curTab = 'mail'" :class="{ active: curTab === 'mail' }" v-if="checkIfTabAvailable('mail')"
            >{{ $t("message.mailNotifications") }}
          </a>
          <a @click="curTab = 'users'" :class="{ active: curTab === 'users' }" v-if="checkIfTabAvailable('users')"
            >{{ $t("message.users") }}
          </a>
        </div>
        <!-- Contento principale   -->
        <div id="main-content">
          <!-- Gestione -->
          <div v-if="curTab === 'manage'">
            <div class="sr-heading">
              <p>{{ $t("message.manageDevices") }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-manage-box" v-for="sensor in filteredSensors" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{ sensor.type + " - " + sensor.eui.substr(sensor.eui.length - 4) }}
                </h4>
                <input
                  type="text"
                  class="sensor-manage-name input-text"
                  :ref="sensor.eui"
                  spellcheck="false"
                  maxlength="10"
                  minlength="1"
                  v-model="sensor.userConfig.name"
                  :disabled="!sensor.userConfig.editing"
                />
                <img class="sensor-manage-edit icon" src="../../public/assets/icons/edit.svg" @click="editUserConfig(sensor)" />
                <img class="sensor-manage-changecolor icon" src="../../public/assets/icons/changecolor.svg" />
                <div class="dropdown">
                  <div class="dropdown-content">
                    <div
                      v-for="(color, key, index) in colors"
                      :key="index"
                      class="dot"
                      :style="{ backgroundColor: color }"
                      @click="sensor.userConfig.color = color"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Soglia allarme -->
          <div v-if="curTab === 'threshold'">
            <div class="sr-heading">
              <p>{{ $t("message.alertDevices") }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-manage-box" v-for="sensor in filteredSensors.filter((i) => !i.subType)" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{ sensor.type + " - " + sensor.eui.substr(sensor.eui.length - 4) }}
                </h4>
                <div class="threshold-field">
                  <h2>{{ "[" + (mesaurementUnit || " - ") + "]" }}</h2>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    :ref="sensor.eui"
                    class="sensor-manage-threshold"
                    spellcheck="false"
                    maxlength="10e"
                    :value="convertedFrontMes(sensor.userConfig.threshold)"
                    @change="sensor.userConfig.threshold = parseFloat(convertedBackMes($event.target.value))"
                    :disabled="!sensor.userConfig.editing"
                    @keydown.enter="editUserConfig(sensor)"
                  />
                </div>
                <img class="sensor-manage-edit icon" src="../../public/assets/icons/edit.svg" @click="editUserConfig(sensor)" />
              </div>
            </div>
          </div>
          <!-- Samplerate -->
          <div v-if="this.curTab === 'samplerate'">
            <div class="sr-heading">
              <p>{{ $t("message.setSampleRate") }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-box" v-for="sensor in filteredSensors" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{ sensor.type + " " + sensor.eui.substr(sensor.eui.length - 4) + " - " + sensor.userConfig.name }}
                </h4>
                <p class="sensor-caption">{{ $t("message.sampleRate") }}:</p>
                <div class="options-wrap">
                  <div
                    class="checkbox-container"
                    v-for="sr in curOption === 'tiltmeter' ? sampleRates.tiltmeters : sampleRates.accelerometers"
                    :key="sr.value"
                  >
                    <label class="container">
                      <input type="radio" :name="'radio_' + sensor.eui" :value="sr.value" v-model.number="sensor.userConfig.sampleRate" />
                      <span class="checkmark"></span>
                    </label>
                    <label class="value">{{ sr.label }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Risoluzione -->
          <div v-if="this.curTab === 'resolution'">
            <div class="sr-heading">
              <p>{{ $t("message.setResolution") }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-box" v-for="sensor in filteredSensors" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{
                    sensor.type + " " + sensor.eui.substr(sensor.eui.length - 4) + " (" + sensor.rev + ")" + " - " + sensor.userConfig.name
                  }}
                </h4>
                <p class="sensor-caption">Resolution [{{ mesaurementUnit }}] / Full Scale ({{ mesaurementUnit }}-pp):</p>
                <div class="options-wrap" v-if="sensor.rev != '1.0'">
                  <div class="checkbox-container" v-for="sr in filteredResolutions" :key="sr.value">
                    <label class="container">
                      <input type="radio" :name="'radio_' + sensor.eui" :value="sr.value" v-model.number="sensor.userConfig.resolution" />
                      <span class="checkmark"></span>
                    </label>
                    <label class="value">{{ sr.label }}</label>
                  </div>
                </div>
                <div class="options-wrap" v-else>
                  <p><i>Funzione non supportata da questa versione</i></p>
                </div>
              </div>
            </div>
          </div>
          <!-- Unit -->
          <div v-if="this.curTab === 'unit'">
            <div class="sr-heading">
              <p>{{ $t("message.mesUnitSelect") }}:</p>
            </div>
            <div id="sr-content">
              <div class="radio-box">
                <div class="options-wrap">
                  <div class="checkbox-container" v-for="unit in filteredUnits" :key="unit.value">
                    <label class="container">
                      <input
                        v-if="interfaceSettings && interfaceSettings.dimensions"
                        type="radio"
                        :value="unit.value"
                        :name="'radio_unit_' + unit.value"
                        v-model="interfaceSettings.dimensions.degrees"
                      />
                      <span class="checkmark"></span>
                    </label>
                    <label class="value">{{ unit.label }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Soglia attivazione -->
          <div v-if="this.curTab === 'activationThreshold'">
            <div class="sr-heading">
              <p>{{ $t("message.setActivationThreshold") }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-manage-box" v-for="sensor in filteredSensors" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{ sensor.type + " - " + sensor.eui.substr(sensor.eui.length - 4) }}
                </h4>
                <div class="threshold-field">
                  <h2>{{ "[" + (mesaurementUnit || " - ") + "]" }}</h2>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    :ref="sensor.eui"
                    class="sensor-manage-threshold"
                    spellcheck="false"
                    maxlength="10e"
                    v-model.number="sensor.userConfig.activationThreshold"
                    :disabled="!sensor.userConfig.editing"
                    @keydown.enter="editUserConfig(sensor)"
                  />
                </div>
                <img class="sensor-manage-edit icon" src="../../public/assets/icons/edit.svg" @click="editUserConfig(sensor)" />
              </div>
            </div>
          </div>
          <!-- Position -->
          <div v-if="this.curTab === 'position'">
            <div class="sr-heading">
              <p>{{ $t("message.setSensorSpan") }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-manage-box" v-for="sensor in filteredSensors" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{ sensor.type + " - " + sensor.eui.substr(sensor.eui.length - 4) }}
                </h4>
                <div class="threshold-field">
                  <h2>{{ $t("message.span") }}</h2>
                  <select
                    id="type"
                    v-model.number="sensor.userConfig.spanNumber"
                    :class="[sensor.userConfig.editing ? '' : 'disabled-select', 'select-options']"
                    @change="
                      sensor.userConfig.valid = checkInputSpan(sensor.userConfig.spanDistance, sensor.userConfig.spanNumber);
                      sensor.userConfig.spanDistance = sensor.userConfig.spanNumber === null ? null : sensor.userConfig.spanDistance;
                    "
                  >
                    <option :value="null" :disabled="!sensor.userConfig.editing">None</option>
                    <option
                      :value="index + 1"
                      v-for="(span, index) in structure.userConfig.spansDetails"
                      :key="index"
                      :disabled="!sensor.userConfig.editing"
                    >
                      {{ index + 1 }}
                    </option>
                  </select>
                  <h2>{{ "[m]" }}</h2>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    :ref="sensor.eui"
                    class="sensor-manage-threshold"
                    spellcheck="false"
                    maxlength="10e"
                    v-model.number="sensor.userConfig.spanDistance"
                    @input="sensor.userConfig.valid = checkInputSpan(sensor.userConfig.spanDistance, sensor.userConfig.spanNumber)"
                    :disabled="!sensor.userConfig.editing"
                    @keydown.enter="editUserConfig(sensor)"
                  />
                </div>
                <img class="sensor-manage-edit icon" src="../../public/assets/icons/edit.svg" @click="editUserConfig(sensor)" />
              </div>
            </div>
          </div>
          <!-- Spans -->
          <div v-if="this.curTab === 'spans'">
            <div class="sr-heading">
              <p>{{ $t("message.setSpans") }}:</p>
            </div>
            <div id="sr-content">
              <div class="span-box" v-for="(span, index) in structure.userConfig.spansDetails" :key="index + 1">
                <h4 class="sensor-manage-eui span-name">
                  {{ index + 1 }}
                </h4>
                <div class="threshold-field span-name-field">
                  <h2>{{ "Nome" }}</h2>
                  <input
                    type="text"
                    min="0"
                    step="any"
                    :ref="'span_' + index"
                    class="sensor-manage-threshold input-text"
                    pattern="(?=.{1,24}$)^[a-zA-Z0-9_@.#+-]+( [a-zA-Z0-9_@.#+-]+)*$"
                    spellcheck="false"
                    maxlength="23e"
                    v-model="span.name"
                    :disabled="!span.editing"
                    @input="span.valid = checkInputSpanName(span.name)"
                    @keydown.enter="editSpanConfig(span, index)"
                  />
                </div>
                <div class="threshold-field span-lenght-field">
                  <h2>{{ "[m]" }}</h2>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    :ref="'span_' + index"
                    class="sensor-manage-threshold"
                    spellcheck="false"
                    maxlength="10e"
                    v-model.number="span.length"
                    :disabled="!span.editing"
                    @input="span.valid = checkInputSpan(span.length)"
                    @keydown.enter="editSpanConfig(span, index)"
                  />
                </div>
                <img
                  v-if="span.editing"
                  class="mail-edit-icon icon"
                  src="../../public/assets/icons/accept.svg"
                  @click="editSpanConfig(span, index)"
                />
                <img v-else class="mail-edit-icon icon" src="../../public/assets/icons/edit.svg" @click="editSpanConfig(span, index)" />
                <img
                  v-if="span.editing"
                  class="mail-delete-icon icon"
                  src="../../public/assets/icons/trash.svg"
                  @click="deleteSpan(span, index)"
                />
              </div>
              <div class="add-box">
                <h5 @click="insertNewSpan">
                  {{ $t("message.addSpan") }}
                </h5>
              </div>
            </div>
          </div>
          <!-- Compensazione -->
          <div v-if="this.curTab === 'compensation'">
            <div class="sr-heading">
              <p>{{ $t("message.resetCompensation") }}:</p>
              <button type="button" class="button" @click="resetAllSensorsOffset">
                {{ $t("message.resetAll") }}
              </button>
            </div>
            <div id="sr-content">
              <div class="sensor-box" v-for="sensor in filteredSensors.filter((i) => !i.subType)" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{ sensor.type + " " + sensor.eui.substr(sensor.eui.length - 4) + " - " + sensor.userConfig.name }}
                </h4>
                <p class="sensor-caption">
                  {{ !sensor.baseValue && !sensor.baseTilt ? $t("message.notCompensated") : $t("message.compensated") }}
                </p>
                <div class="options-wrap compensation-opt">
                  <button type="button" class="button" @click="resetOffset(sensor)">Reset Offset</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Posizione -->
          <div v-if="this.curTab === 'position'">
            <div class="sr-heading">
              <p>{{ $t("message.setActivationThreshold") }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-manage-box" v-for="sensor in filteredSensors" :key="sensor.eui">
                <div class="side-color" :style="{ backgroundColor: sensor.userConfig.color }"></div>
                <h4 class="sensor-manage-eui">
                  {{ sensor.type + " - " + sensor.eui.substr(sensor.eui.length - 4) }}
                </h4>
                <div class="threshold-field">
                  <h2>{{ "[m]" }}</h2>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    :ref="sensor.eui"
                    class="sensor-manage-threshold"
                    spellcheck="false"
                    maxlength="10e"
                    v-model.number="sensor.userConfig.spanDistance"
                    :disabled="!sensor.userConfig.editing"
                    @keydown.enter="editUserConfig(sensor)"
                  />
                </div>
                <img class="sensor-manage-edit icon" src="../../public/assets/icons/edit.svg" @click="editUserConfig(sensor)" />
              </div>
            </div>
          </div>
          <!-- Notifications Tab -->
          <div v-if="curOption === 'notifications'">
            <div class="notify-heading">
              <h4>{{ $t("message.mailAddresses") }}</h4>
              <p>
                {{ $t("message.mailAddressesExplain") }}
              </p>
            </div>
            <div id="sr-content">
              <div class="item-box" v-for="(mail, index) in mails" :key="index">
                <input
                  tabindex="0"
                  type="text"
                  pattern="(?=.{4,24}$)^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$"
                  class="input-text mail-name"
                  spellcheck="false"
                  placeholder="Inserisci Nome"
                  minlength="4"
                  v-model="mail.name"
                  :disabled="!mail.editing"
                  @input="mail.valid = checkInputEmail(mail)"
                  required
                />
                <input
                  tabindex="1"
                  type="email"
                  class="input-text mail-addr"
                  spellcheck="false"
                  placeholder="Inserisci Mail"
                  minlength="4"
                  v-model="mail.mail"
                  :disabled="!mail.editing"
                  @input="mail.valid = checkInputEmail(mail)"
                  required
                />
                <div class="alert-sensor-types">
                  <input type="checkbox" name="deck" id="" v-model="mail.sensorTypes" :value="'deck'" />
                  <label for="deck">{{ $t("message.decks") }}</label>
                  <input type="checkbox" name="Accelerometer" id="" v-model="mail.sensorTypes" :value="'accelerometer'" />
                  <label for="deck">{{ $t("message.accelerometers") }}</label>
                  <input type="checkbox" name="Tiltmeters" id="" v-model="mail.sensorTypes" :value="'tiltmeter'" />
                  <label for="deck">{{ $t("message.tiltmeters") }}</label>
                  <input type="checkbox" name="Crackmeters" id="" v-model="mail.sensorTypes" :value="'crackmeter'" />
                  <label for="deck">{{ $t("message.crackmeters") }}</label>
                  <input type="checkbox" name="AnalogNodes" id="" v-model="mail.sensorTypes" :value="'analog-node'" />
                  <label for="AnalogNodes">{{ $t("message.analogNodes") }}</label>
                </div>
                <img v-if="mail.editing" class="mail-edit-icon icon" src="../../public/assets/icons/accept.svg" @click="editMail(mail)" />
                <img v-else class="mail-edit-icon icon" src="../../public/assets/icons/edit.svg" @click="editMail(mail)" />
                <img
                  v-if="mail.editing"
                  class="mail-delete-icon icon"
                  src="../../public/assets/icons/trash.svg"
                  @click="deleteMail(mail)"
                />
                <label class="switch" v-else
                  ><input type="checkbox" v-model="mail.alertsOn" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="add-box">
                <img class="mail-new-icon icon" src="../../public/assets/icons/newavatar.svg" @click="insertNewMail" />
                <h5 @click="insertNewMail">
                  {{ $t("message.newMailAddress") }}
                </h5>
              </div>
            </div>
          </div>
          <!-- Sotto Utenti -->
          <div v-if="curOption === 'users'">
            <div class="notify-heading">
              <h4>{{ $t("message.users") }}</h4>
              <p>{{ $t("message.manageUsers") }}</p>
            </div>
            <div id="sr-content">
              <div class="item-box" v-for="(subUser, index) in subUsers" :key="index">
                <input
                  tabindex="0"
                  type="text"
                  pattern="(?=.{4,24}$)^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$"
                  class="input-text mail-name"
                  spellcheck="false"
                  placeholder="Username"
                  minlength="4"
                  v-model="subUser.username"
                  :disabled="!subUser.editing"
                  @input="subUser.valid = checkInputSubUser(subUser)"
                  required
                />
                <input
                  tabindex="1"
                  type="password"
                  class="input-text mail-addr"
                  spellcheck="false"
                  :placeholder="$t('message.editPsw')"
                  pattern="(^$|^(?:(?=.*?[A-Z])(?:(?=.*?[0-9])(?=.*?[-!@#$%^&*()_[\]{},.<>+=])|(?=.*?[a-z])(?:(?=.*?[0-9])|(?=.*?[-!@#$%^&*()_[\]{},.<>+=])))|(?=.*?[a-z])(?=.*?[0-9])(?=.*?[-!@#$%^&*()_[\]{},.<>+=]))[A-Za-z0-9!@#$%^&*()_[\]{},.<>+=-]{7,50}$)"
                  v-model="subUser.password"
                  :disabled="!subUser.editing"
                  @input="subUser.valid = checkInputSubUser(subUser)"
                />
                <img
                  v-if="subUser.editing"
                  class="mail-edit-icon icon"
                  src="../../public/assets/icons/accept.svg"
                  @click="editSubUser(subUser)"
                />
                <img v-else class="mail-edit-icon icon" src="../../public/assets/icons/edit.svg" @click="editSubUser(subUser)" />
                <img
                  v-if="subUser.editing"
                  class="mail-delete-icon icon"
                  src="../../public/assets/icons/trash.svg"
                  @click="deleteSubUser(subUser)"
                />
              </div>
              <div class="add-box">
                <img class="mail-new-icon icon" src="../../public/assets/icons/newavatar.svg" @click="insertNewSubUser" />
                <h5 @click="insertNewSubUser">
                  {{ $t("message.addUser") }}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div id="footer">
          <div class="footer-btn" v-if="this.curTab != 'compensation'">
            <button type="button" class="button" @click="closeMe">
              {{ $t("message.undo") }}
            </button>
            <button type="button" class="button save" @click="saveAllSettings" :disabled="!validate">
              {{ $t("message.saveChanges") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../services/api";
import SmallLoadingLogo from "../components/ui/SmallLoadingLogo";
//import draggable from "../helpers/draggable";
import validate from "../helpers/validate";
import math from "../helpers/math";
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";

export default {
  name: "settings",
  props: {
    selectedStructure: Object,
    userType: String,
  },
  components: {
    SmallLoadingLogo,
  },
  data() {
    return {
      loaded: false,
      multiUser: true,
      curOption: "notifications",
      curTab: "manage",
      needPageRefresh: false,
      sensors: [],
      structure: {},
      mails: [],
      subUsers: [],
      interfaceSettings: {},
      sensorPriority: ["deck", "tiltmeter", "accelerometer", "crackmeter"],
      sampleRates: {
        tiltmeters: [
          { value: 2, label: "2 min.", default: true },
          { value: 5, label: "5 min." },
          { value: 15, label: "15 min." },
          { value: 30, label: "30 min." },
        ],
        accelerometers: [
          { value: 1, label: "1 hr." },
          { value: 2, label: "2 hr." },
          { value: 6, label: "6 hr." },
          { value: 12, label: "12 hr." },
          { value: 24, label: "24 hr." },
        ],
      },
      /*       resolutions: {
		accelerometers: [
		  {value:0.25, label:"0.25/64"},
		  {value:0.5, label:"0.5/128"},
		  {value:1, label:"1/256"}
		]
	  }, */
      colors: ["white", "silver", "gray", "black", "red", "yellow", "green", "aqua", "blue", "navy", "fuchsia", "purple"],
      tabPerOptions: [
        {
          type: "deck",
          active: ["manage", "threshold", "resolution", "activationThreshold"],
        },
        {
          type: "tiltmeter",
          active: ["manage", "threshold", "samplerate", "compensation", "unit", "position"],
        },
        {
          type: "accelerometer",
          active: ["manage", "threshold", "resolution", "activationThreshold", "samplerate"],
        },
        { type: "crackmeter", active: ["manage", "threshold", "compensation"] },
        { type: "notifications", active: ["mail"] },
        { type: "users", active: ["users"] },
        { type: "structure", active: "spans" },
      ],
    };
  },
  methods: {
    ...mapActions({
      fetchStructures: "structure/fetchStructures",
      selectStructure: "structure/selectStructure",
      fetchStructureData: "structure/fetchStructureData",
      saveUserSettings: "user/saveUserSettings",
      logout: "auth/logout",
    }),
    // Converte il valore dall'unità di misura nativa a quella impostata
    convertedFrontMes(value) {
      if (this.curOption === "tiltmeter") {
        if (this.interfaceSettings.dimensions && this.interfaceSettings.dimensions.degrees === "mm/m") {
          return math.toFixedIfNecessary(math.degreesToMM(value), 4);
        } else {
          return value;
        }
      } else {
        return value;
      }
    },
    // Converte il valore dall'unità di misura impostata a quella nativa
    convertedBackMes(value) {
      if (this.curOption === "tiltmeter") {
        if (this.interfaceSettings && this.interfaceSettings.dimensions.degrees === "mm/m") {
          return math.toFixedIfNecessary(math.mmTODegrees(value), 6);
        } else {
          return value;
        }
      } else {
        return value;
      }
    },
    /* Inserisce una nuova mail vuota */
    insertNewMail() {
      let someInvalid = this.mails ? this.mails.some((mail) => !mail.valid) : false;
      if (!someInvalid) {
        let emptyMail = {
          name: "",
          mail: "",
          sensorTypes: ["deck", "accelerometer", "tiltmeter", "crackmeter"],
          alertsOn: false,
          editing: true,
          valid: false,
        };

        this.mails.push(emptyMail);
      }
    },
    /* Inserisce un nuovo sotto utente vuoto */
    insertNewSubUser() {
      let someInvalid = this.subUsers ? this.subUsers.some((su) => !su.valid) : false;
      if (!someInvalid) {
        let emptyUser = {
          username: "",
          password: null,
          editing: true,
          valid: false,
        };
        this.subUsers.push(emptyUser);
      }
    },
    /* Inserisce una nuova campata del ponte */
    insertNewSpan() {
      let emptySpan = {
        name: (this.structure.userConfig.spansDetails.length + 1).toString(),
        length: 0,
        editing: true,
        valid: false,
      };
      this.structure.userConfig.spansDetails.push(emptySpan);
    },
    /* Salva TUTTE le impostazioni */
    async saveAllSettings() {
      let res1 = this.saveUserSettings({
        mails: this.mails.map((mail) => ({
          mail: mail.mail,
          sensorTypes: mail.sensorTypes,
          name: mail.name,
          alertsOn: mail.alertsOn,
        })),
        interface: this.interfaceSettings,
      });
      let res2 = api.saveSensorsSettings({
        sensors: this.sensors.map((sensor) => ({
          eui: sensor.eui,
          type: sensor.type,
          rev: sensor.rev,
          userConfig: {
            name: sensor.userConfig.name,
            threshold: sensor.userConfig.threshold,
            sampleRate: sensor.userConfig.sampleRate,
            resolution: sensor.userConfig.resolution,
            activationThreshold: sensor.userConfig.activationThreshold,
            spanDistance: isNaN(parseFloat(sensor.userConfig.spanDistance)) ? null : sensor.userConfig.spanDistance,
            spanNumber: sensor.userConfig.spanNumber,
            color: sensor.userConfig.color,
          },
        })),
      });
      let res3 = api.saveStructSettings({
        structureID: this.selectedStructure._id,
        userConfig: {
          ...this.structure.userConfig,
          spansDetails: this.structure.userConfig.spansDetails.map((sd) => ({ name: sd.name, length: sd.length })),
        },
      });
      let res4 = this.saveSubUsers();
      await Promise.all([res1, res2, res3, res4]);
      this.needPageRefresh = false; // Refresh già qui direttamente
      await this.fetchStructureData();
      this.closeMe();
    },
    async saveSubUsers() {
      // Discrimo nuovi e vecchi utenti da modificare in base all'esistenza del campo _id
      this.exsistingUsers = await api.getSubUsers();
      let newUsers = this.subUsers.filter((su) => !su._id);
      let oldUsers = this.subUsers.filter((su) => su._id);
      let deletedUsers = this.exsistingUsers.filter((us) => !this.subUsers.find((sub) => sub._id === us._id));
      let userPromises = [];
      userPromises.push(newUsers.map((newUser) => api.insertNewSubUser(newUser.username, newUser.password)));
      userPromises.push(oldUsers.map((oldUser) => api.updateSubUser(oldUser._id, oldUser.username, oldUser.password)));
      userPromises.push(deletedUsers.map((delUser) => api.deleteSubUser(delUser._id)));
      await Promise.all(userPromises);
    },
    checkIfTabAvailable(tab) {
      // Controlla che la tab sia disponibile per l'opzione selezionata
      let found = false;
      this.tabPerOptions.forEach((option) => {
        if (this.curOption === option.type && option.active.includes(tab)) found = true;
      });
      return found;
    },
    checkSensType(type) {
      // Ritorna true se esiste almeno un sensore di tipo 'type'
      return this.sensors.some((sensor) => sensor.type === type);
    },
    editMail(mail) {
      // Se non ci sono altre mail non valide, abilita editing
      let someInvalid = this.mails.some((mail) => !mail.valid);
      if (!someInvalid) {
        if (mail.editing) {
          mail.editing = false;
        } else {
          this.mails.forEach((mail) => {
            mail.editing = false;
          });
          mail.editing = true;
        }
      }
    },
    editSubUser(subUser) {
      // Se non ci sono altre mail non valide, abilita editing
      let someInvalid = this.subUsers.some((user) => !user.valid);
      if (!someInvalid) {
        if (subUser.editing) {
          subUser.editing = false;
        } else {
          this.subUsers.forEach((user) => {
            user.editing = false;
          });
          subUser.editing = true;
        }
      }
    },
    editUserConfig(sensor) {
      // Se non ci sono altre mail non valide, abilita editing
      let someInvalid = this.sensors.some((sensor) => !sensor.userConfig.valid);
      if (!someInvalid) {
        if (sensor.userConfig.editing) {
          sensor.userConfig.editing = false;
        } else {
          this.sensors.forEach((sensor) => {
            sensor.userConfig.editing = false;
          });
          sensor.userConfig.editing = true;
          setTimeout(() => {
            this.$refs[sensor.eui][0].focus();
          }, 0);
        }
      }
    },
    editSpanConfig(span, index) {
      // Se non ci sono altre mail non valide, abilita editing
      let someInvalid = this.structure.userConfig.spansDetails.some((span) => !span.valid);
      if (!someInvalid) {
        if (span.editing) {
          span.editing = false;
        } else {
          this.structure.userConfig.spansDetails.forEach((span) => {
            span.editing = false;
          });
          span.editing = true;
          setTimeout(() => {
            this.$refs["span_" + index][0].focus();
          }, 0);
        }
      }
    },
    deleteMail(mail) {
      // Elimina mail
      const index = this.mails.indexOf(mail);
      if (index > -1) {
        this.mails.splice(index, 1);
      }
    },
    deleteSubUser(user) {
      // Elimina mail
      const index = this.subUsers.indexOf(user);
      if (index > -1) {
        this.subUsers.splice(index, 1);
      }
    },
    deleteSpan(span) {
      // Elimina span
      if (this.structure.userConfig.spansDetails.length > 0) {
        const index = this.structure.userConfig.spansDetails.indexOf(span);
        if (index > -1) {
          this.structure.userConfig.spansDetails.splice(index, 1);
          // Verifico che le impostazioni delle campate siano coerenti
          for (let i = 0; i < this.sensors.length; i++) {
            if (this.sensors[i].userConfig.spanNumber === index + 1) {
              this.sensors[i].userConfig.spanNumber = null;
              this.sensors[i].userConfig.spanDistance = null;
            }
            if (this.sensors[i].userConfig.spanNumber > index + 1) {
              this.sensors[i].userConfig.spanNumber -= 1;
            }
          }
        }
      }
    },
    /* Resetta l'Offset di tutti i sensori */
    async resetAllSensorsOffset() {
      if (confirm(this.$t("message.irreversibleWarning"))) {
        let resetPromises = this.filteredSensors.map((s) => api.resetOffset(s.eui));
        await Promise.all(resetPromises);
        this.needPageRefresh = true;
      }
    },
    /* Resetta l'Offset di quel specifico sensore */
    async resetOffset(sensor) {
      if (confirm(this.$t("message.irreversibleWarning"))) {
        sensor.baseValue = await api.resetOffset(sensor.eui);
        this.needPageRefresh = true;
      }
    },
    checkInputEmail(mail) {
      return validate.validateEmail(mail.mail) && validate.validateName(mail.name);
    },
    checkInputSubUser(subUser) {
      return validate.validateUsername(subUser.username) && (validate.validatePassword(subUser.password) || !subUser.password);
    },
    checkInputSpan(spanLength, spanNumber) {
      return (!isNaN(spanLength) && spanLength > 0) || spanNumber === null;
    },
    checkInputSpanName(spanName) {
      return validate.validateNameNoSpaceBeginning(spanName);
    },
    closeMe() {
      this.$emit("settingstoggle");
    },
  },
  computed: {
    ...mapGetters({
      getUserMails: "user/getMails",
      getUserInterface: "user/getInterface",
    }),
    isLambro(){
      return this.sensors.some(sn => sn.eui === "C0EE400001015144")
    },
    convertedThreshold: {
      get() {
        return this.componentGetObject.toEmail;
      },
      set(val) {
        this.componentSignal({ pro: "toEmail", val });
      },
    },
    filteredSensors() {
      return this.sensors.filter((sensor) => sensor.type === this.curOption);
    },
    filteredUnits() {
      let units;
      if (this.curOption === "tiltmeter") {
        units = [
          { label: "degrees", value: "degrees" },
          { label: "mm/m", value: "mm/m" },
        ];
      }
      return units;
    },
    filteredResolutions() {
      let resolutions;
      if (this.curOption === "deck") {
        resolutions = [
          { value: 0.012, label: "0.012/3" },
          { value: 0.024, label: "0.024/6" },
        ];
      }
      if (this.curOption === "accelerometer") {
        resolutions = [
          { value: 0.25, label: "0.25/64" },
          { value: 0.5, label: "0.5/128" },
          { value: 1, label: "1/256" },
        ];
      }
      return resolutions;
    },
    tiltmeters() {
      return this.sensors.filter((sensor) => sensor.type === "tiltmeter");
    },
    mesaurementUnit() {
      let unit;
      if (this.curOption === "deck") unit = "mm";
      if (this.curOption === "crackmeter") unit = "mm";
      if (this.curOption === "accelerometer") unit = "mg";
      if (this.curOption === "tiltmeter")
        unit = this.interfaceSettings.dimensions && this.interfaceSettings.dimensions.degrees === "mm/m" ? "mm/m" : "degrees";
      return unit;
    },
    validate() {
      let mailCheck = this.mails ? !this.mails.some((mail) => mail.editing) : true;
      let sensorsCheck = !this.sensors.some((sensor) => !sensor.userConfig.valid);
      let spanCheck =
        this.structure.userConfig && this.structure.userConfig.spansDetails
          ? !this.structure.userConfig.spansDetails.some((sd) => sd.editing)
          : true;
      return mailCheck && spanCheck && sensorsCheck;
    },
  },
  watch: {
    curTab: function () {
      // Quando cambio tab disattivo l'editing dei sensori
      this.sensors.map((a) => (a.userConfig.editing = false));
    },
    curOption: function () {
      // Quando cambio opzione disattivo l'editing dei sensori
      this.sensors.map((a) => (a.userConfig.editing = false));
    },
  },
  async mounted() {
    $(document.body).addClass("modal-open"); // Blocco scorrimento body
    /* Deep copy delle mail */
    if (this.getUserMails) {
      const mailFromAPI = JSON.parse(JSON.stringify(this.getUserMails));
      this.mails = mailFromAPI
        ? mailFromAPI.map((mail) => ({
            ...mail,
            editing: false,
            valid: true,
          }))
        : [];
    }
    /* Deep copy user settings */
    if (this.getUserInterface) {
      this.interfaceSettings = JSON.parse(JSON.stringify(this.getUserInterface));
    }
    /* Deep copy sotto utenti */
    const subUsersFromAPI = JSON.parse(JSON.stringify(await api.getSubUsers()));
    this.subUsers = subUsersFromAPI
      ? subUsersFromAPI.map((user) => ({
          ...user,
          editing: false,
          valid: true,
        }))
      : [];
    /* Deep copy della struttura */
    this.structure = JSON.parse(
      JSON.stringify({
        userConfig: {
          spansDetails: this.selectedStructure.userConfig.spansDetails.map((sd) => ({ ...sd, editing: false, valid: true })),
        },
      })
    );
    /* Deep copy dei sensor */
    const sensorsFromApi = JSON.parse(JSON.stringify(await api.getSensorsSettings(this.selectedStructure._id)));
    this.sensors = sensorsFromApi
      ? sensorsFromApi.map((sensor) => ({
          eui: sensor.eui,
          type: sensor.type,
          rev: sensor.rev,
          baseValue: sensor.baseValue,
          baseTilt: sensor.baseTilt,
          subType: sensor.subType,
          userConfig: {
            ...sensor.userConfig,
            spanNumber: sensor.userConfig.spanNumber || null,
            editing: false,
            valid: true,
          },
        }))
      : [];
    /* 
    Scorro i sensori per selezionare la prima optin in base alla
    priorità in sensorPriority
    */
    for (const type of this.sensorPriority) {
      if (this.sensors.some((a) => a.type == type)) {
        //this.curOption = type;
        break;
      }
    }
    this.loaded = true;
  },
  async beforeDestroy() {
    $(document.body).removeClass("modal-open"); // Consento al body di scorrere di nuovo
    if (this.needPageRefresh) {
      await this.fetchStructureData();
    }
  },
};
</script>
<style lang="postcss" scoped>
* {
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  color: white;
}
input[disabled] {
  pointer-events: none;
}

.dark-overlay {
  background-color: rgba(0, 0, 0, 0.27);
  width: 100%;
  height: 100%;
  position: absolute;
}
body {
  background-color: white !important;
}
h1 {
  font-size: 1.3em;
}
p {
  font-size: 0.8em;
  color: rgb(198, 198, 198);
  padding: 0px;
}
.horiz-divider {
  background-color: grey;
  height: 2px;
  margin: 4px 0;
}
.input-text {
  background-color: rgba(0, 0, 0, 0);
  width: 120px;
  font-size: 1em;
  outline-width: 0;
  outline: none !important;
  border: none;
  display: inline;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  padding-bottom: 1%;
  white-space: nowrap;
  display: flex;
  align-items: center;
  align-self: center;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
}
.input-text:enabled {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}
.input-text:invalid {
  border: solid 1.2px red !important;
  padding: 1px;
}
.input-text:valid {
  border: solid 1.2px green !important;
  padding: 1px;
}
.settings-container {
  width: 60vw;
  height: 64vh;
  min-width: 1080px;
  min-height: 400px;
  top: 22vh;
  left: 0;
  position: sticky;
  grid-template-columns: 1.8fr 8.2fr;
  grid-template-rows: 1fr 1.1fr 6.9fr 1fr;
  border-radius: 10px;
  overflow: hidden;
  display: grid;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
}
.options {
  height: 40%;
  display: grid;
  text-align: left;
  padding-top: 0.8vw;
  height: 40%;
  display: grid;
  text-align: left;
  grid-template: none;
  align-items: center;
}
.options > a {
  padding-left: 1.2vw;
  font-size: 0.95em;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: default;
  margin: 14px 0;
}

/* selected link */
.options > a.active {
  background-color: rgb(32, 34, 47);
}
.options > a.disabled {
  color: gray;
  pointer-events: none;
  cursor: default;
}
#settings-header {
  background-color: rgb(45, 48, 65);
  height: 100%;
  min-height: 45px;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row: 1;
  z-index: 11;
  display: flex;
  align-items: center;
  padding-left: 1.2vw;
  border-bottom: solid 2px white;
}
#side-options {
  height: 100%;
  min-width: 120px;
  background-color: rgb(45, 48, 65);
  grid-row-start: 2;
  grid-row-end: 5;
  grid-column: 1;
  z-index: 10;
  position: relative;
  border-right: solid 2px white;
  display: grid;
  grid-template-rows: auto;
}
#main-content {
  background-color: rgb(45, 48, 65);
  grid-row: 3;
  grid-column: 2;
  padding-left: 4%;
  padding-right: 4%;
  padding-top: 1.8vw;
  overflow-y: scroll;
  overflow-x: hidden;
}

#tab {
  position: relative;
  background-color: rgb(45, 48, 65);
  grid-row: 2;
  width: 100%;
  border-bottom: solid 0.8px gray;
  align-items: center;
  display: grid;
  grid-auto-rows: 100%;
  z-index: 2;
  grid-template-columns: repeat(6, 10fr);
  -webkit-box-shadow: 1px - 10px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 1px 8px 10px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 1px 8px 10px 0px rgba(0, 0, 0, 0.4);
}
#tab > a {
  white-space: nowrap;
  align-self: center;
  cursor: default;
  font-size: 0.9em;
  align-self: end;
  font-weight: 600;
  font-size: 0.8em;
  padding-bottom: 7px;
  padding-top: 7px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  box-sizing: border-box;
}
#tab > a:hover {
  background-color: rgb(80, 84, 105);
}
#tab > a.active {
  border-bottom: solid 3px rgb(21, 146, 230);
  padding-bottom: 4px;
  color: rgb(21, 146, 230);
}
#tab > a.disabled {
  color: gray;
  pointer-events: none;
  cursor: default;
}
#footer {
  background-color: rgb(45, 48, 65);
  border-top: solid 0.8px gray;
  height: 100%;
  grid-column: 2;
  grid-row: 4;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 2;
  -webkit-box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
}
#sr-content {
  height: 100%;
}
.sr-heading {
  text-align: left;
  margin-bottom: 25px;
  height: 35px;
  display: flex;
  align-items: center;
}
.sr-heading > h4 {
  margin: 0;
}
.sr-heading > p {
  margin: 0;
}
.checkbox-container {
  display: grid;
  width: 100%;
  justify-items: center;
}
.sensor-box {
  height: 80px;
  text-align: left;
  border-bottom: solid 1px grey;
  display: grid;
  grid-template-columns: 2% 49% 49%;
  grid-template-rows: 50% 50%;
  padding-top: 1%;
}
.sensor-box > .sensor-head {
  margin: 0;
  font-weight: 700;
  grid-column: 2;
  grid-row: 1;
  align-self: center;
}
.sensor-box > .sensor-caption {
  margin: 0;
  grid-column: 2;
  grid-row: 2;
  align-self: center;
}

.sensor-box > input {
  grid-column: 3;
  grid-row: 2;
}

.sensor-manage-box {
  height: 80px;
  text-align: left;
  border-bottom: solid 2px rgba(255, 255, 255, 0.15);
  display: grid;
  grid-template-columns: 2% 60% 20% 9% 9%;
  grid-template-rows: 50% 50%;
  padding-top: 1%;
}
.sensor-manage-eui {
  margin: 0;
  white-space: nowrap;
  font-weight: 700;
  font-size: 0.9em;
  align-self: center;
  padding-top: 1%;
  grid-column: 2;
  grid-row: 1;
}
.sensor-manage-name {
  grid-column: 2;
  grid-row: 2;
}
.threshold-field {
  grid-column: 2;
  grid-row: 2;
  display: flex;
}
.threshold-field > h2 {
  font-weight: 700;
  font-size: 0.8em;
  align-self: center;
  margin: 0;
  padding: 0;
}
.threshold-field > .sensor-manage-threshold {
  background-color: rgba(0, 0, 0, 0);
  width: 150px;
  font-size: 1em;
  outline-width: 0;
  outline: none !important;
  border: none;
  display: inline;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  margin-left: 10px;
  display: flex;
  align-items: center;
  align-self: center;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
}
.threshold-field > .sensor-manage-threshold:enabled {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}
.sensor-manage-box > .sensor-manage-name:enabled {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}
.sensor-manage-box > .sensor-manage-label {
  margin: 0;
  grid-row: 1;
  grid-column: 3;
  align-self: center;
}
.sensor-manage-box > .sensor-manage-edit {
  justify-self: end;
  align-self: end;
  grid-row: 1;
  grid-column: 5;
}
.sensor-manage-box > .sensor-manage-changecolor {
  justify-self: end;
  align-self: end;
  grid-row: 1;
  grid-column: 4;
}
.side-color {
  width: 6px;
  height: 80%;
  align-self: center;
  grid-column: 1;
  background-color: green;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  align-items: center;
}
.select-options {
  margin-right: 10px;
}
.disabled-select {
  background-image: none;
  background-color: rgba(255, 255, 255, 0.15) !important;
}
/* Span */
.span-name {
  grid-column: 1;
}
.span-name-field {
  grid-column: 1;
  grid-row: 2;
  grid-template-columns: 50px auto;
  display: grid;
  padding: 6px 0;
}

.span-lenght-field {
  grid-column: 1;
  grid-row: 3;
  grid-template-columns: 50px auto;
  display: grid;
  padding: 6px 0;
}

.span-box {
  height: fit-content;
  text-align: left;
  border-bottom: solid 2px rgba(255, 255, 255, 0.15);
  display: grid;
  /* grid-template-rows: 50% 50%; */
  padding-top: 1%;
  grid-template-columns: 80% 10% 10%;
}
.span-box > .input-text {
  width: 100%;
}

/* Items */
.item-box {
  height: 80px;
  text-align: left;
  border-bottom: solid 2px rgb(80, 84, 105);
  display: grid;
  grid-template-columns: 4fr 4fr 1fr 1fr;
  column-gap: 20px;
}

.item-box > .input-text {
  width: 100%;
}
.notify-heading {
  text-align: left;
  padding-bottom: 15px;
  margin-bottom: 10px;
  border-bottom: solid 2px rgb(80, 84, 105);
}
.notify-heading > h4 {
  margin: 0;
}
.notify-heading > p {
  margin: 0;
}
.alert-sensor-types {
  grid-column: 2;
  grid-row: 1/3;
  display: grid;
  grid-template-columns: min-content auto min-content auto;
  align-items: center;
  grid-template-rows: max-content max-content;
  margin: auto 0;
}
.item-box > .switch {
  grid-column: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  align-self: center;
}
.mail-edit-icon {
  min-height: 25px;
  width: 25px;
  grid-column: 4;
  grid-row-start: 1;
  grid-row-end: 3;
  justify-self: end;
  align-self: center;
}
.mail-delete-icon {
  min-height: 25px;
  width: 25px;
  grid-column: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  justify-self: end;
  align-self: center;
}
.mail-name {
  grid-column: 1;
  grid-row: 1;
  font-weight: 700;
}
.mail-addr {
  grid-column: 1;
  grid-row: 2;
  font-size: 0.8em;
  margin: 0;
  color: rgb(198, 198, 198);
}
.add-box {
  display: flex;
  align-items: center;
  align-content: center;
}
.add-box > h5 {
  font-size: 0.8em;
  font-weight: 700;
  padding: 8px;
  border-radius: 5px;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
  cursor: pointer;
}
.add-box > h5:hover {
  background-color: rgba(80, 84, 105, 1);
}
.add-box > .mail-new-icon {
  width: 5%;
  margin-right: 2%;
  background-color: rgba(0, 0, 0, 0) !important;
}
::-webkit-scrollbar {
  width: 0.5em;
}
::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.close {
  align-self: center;
  cursor: pointer;
  right: 2%;
  width: 3%;
}
input[type="range"]::-moz-range-track {
  padding: 0 10px;
  background: repeating-linear-gradient(to right, #ccc, #ccc 10%, #000 10%, #000 11%, #ccc 11%, #ccc 20%);
}
.options-wrap {
  width: 100%;
  width: 100%;
  display: flex;
  grid-row-start: 1;
  grid-row-end: 3;
  grid-template-rows: 40% 35%;
  frid-template-columns: 25% 25% 25% 25%;
  -webkit-box-align: end;
  -ms-flex-align: end;
  justify-items: center;
  align-self: end;
}
.compensation-opt {
  align-self: center;
}
.options-wrap > input {
  width: 100%;
  grid-row: 1;
}
.options-wrap > .container {
  grid-row: 1;
}
.options-wrap > .value {
  grid-row: 2;
  justify-self: center;
  font-size: 0.9em;
  color: rgb(198, 198, 198);
  margin-left: 5%;
}

/* Control Buttons */
.footer-btn {
  display: flex;
  height: 35px;
}
.button {
  width: 158px;
  font-size: 0.8em;
  padding: 2%;
  line-height: 100%;
  margin: auto;
  font-weight: 600;
  margin-right: 20px;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: rgb(80, 84, 105);
  border: solid 2px white;
  border-radius: 7px;
  transition: transform 0.1s linear;
}
.button:active {
  background-color: rgb(47, 112, 177);
  transform: translateY(1px);
}
.button:disabled {
  background-color: grey;
}
.button:disabled:hover {
  background-color: grey;
}
.bottom-buttons {
  position: absolute;
  top: 405px;
  left: 458px;
}
.save {
  background-color: rgb(21, 146, 230);
}
.save:hover {
  background-color: rgba(21, 146, 230, 0.8);
}
/* Color Dropdown */
.dropbtn {
  background-color: #4caf50;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}
.dropdown {
  position: relative;
  grid-row: 1;
  grid-column: 4;
}
.dropdown-content {
  transition: visibility 0.2s linear, opacity 0.2s linear;
  -ms-transition: visibility 0.2s linear, opacity 0.2s linear;
  -webkit-transition: visibility 0.2s linear, opacity 0.2s linear;
  display: grid;
  visibility: hidden;
  opacity: 0;
  align-content: center;
  align-items: center;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-rows: 33% 33% 33%;
  position: relative;
  top: -50%;
  right: 74px;
  background-color: rgb(80, 84, 105);
  width: 100px;
  height: 85px;
  border-radius: 5px;
  padding: 5px;
  transition-delay: 0.2s;
}
.dot {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  border: solid 1px white;
}
.dropdown:hover .dropdown-content {
  opacity: 1;
  visibility: visible;
}

/* Edit Icon */
.icon {
  padding: 5px;
  border-radius: 5px;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
}
.icon:hover {
  background-color: rgb(80, 84, 105);
}
/* The container */
.container {
  position: relative;
  display: contents;
  cursor: pointer;
  font-size: 22px;
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
/* Hide the browser's default radio button */
.container input {
  position: absolute;
  top: 50vh;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.checkmark {
  left: 0;
  top: 0;
  height: 14px;
  position: relative;
  width: 14px;
  border-radius: 50%;
  border: solid 3px white;
  z-index: 9;
}
/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: rgb(80, 84, 105);
}
/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  /* background-color: #2196F3; */
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
#settings-outerwrap {
  z-index: 16;
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

#settings-outerwrapheader {
  cursor: move;
}

/* Overlay Info */
.infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-radius: 10px;
  background-color: black;
  opacity: 0.7;
  z-index: 24;
}
.infoi > h2 {
  margin: auto;
  font-weight: 500;
}

/* Loading Transition */
.load-enter,
.load-leave-to {
  opacity: 0;
}
.load-enter-active {
  transition: all 0.1s ease;
}
.load-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
</style>
